<template>
  <tr class="item-order-row">
    <td class="v-align-middle">{{ order.created_at | moment-date-compact }}</td>
    <td>{{ orderType }}</td>
    <td class="v-align-middle">{{ order.ihrez }}</td>
    <td>
      <div v-if="!recoveryData">{{ (order.total_to_pay / 100).toFixed(2) }}€</div>
      <div v-else>Inconnu</div>
    </td>
    <td>
      <div v-if="order.cancelled">Commande annulée</div>
      <div v-else>
        <div class="payment-status">
          {{ order.decoded_payment_status }}
        </div>
        <payment-item 
          v-if="order.payment_status == 'paid' && order.payments && order.payments.length > 0"
          :payment="order.payments[0]"
          :details="false">
        </payment-item>
        <div v-else>
          <b>Validation :</b> {{ order.decoded_validation_method }}
        </div>
      </div>
    </td>
    <td class="v-align-middle text-center">
      <intermediary-business :order="order"></intermediary-business>
    </td>
    <td class="v-align-middle text-center">
      <order-payer :order="order"></order-payer>
    </td>
    <td class="v-align-middle text-center">
      <template>{{ promoCode }}</template>
    </td>
    <td class="v-align-middle text-center">
      <button class="btn btn-complete btn-sm" @click="toggleDetails(order.id)" v-if="!recoveryData">
        <i v-if="toggled" class="fa fa-chevron-up"></i>
        <i v-else class="fa fa-chevron-down"></i>
        Détails
      </button>
      <div class="payment-buttons" v-if="!order.cancelled">
        <button class="btn btn-complete btn sm" @click="$emit('toggle-payment-modal', order)" v-if="order.payment_status === 'pending'">
          Payer
        </button>
        <template v-if="order.stored_in_erp && order.can_be_captured">
          <button class="btn btn-complete btn sm" @click="$emit('capture-authorization', order)" :disabled="captureButtonDisabled">Capturer l'autorisation bancaire</button>
          <button v-if="'paid' === order.payment_status" class="btn btn-complete btn sm" @click="$emit('cancel-authorization', order)" :disabled="cancelButtonDisabled">Annuler l'autorisation bancaire</button>
        </template>
      </div>
    </td>
  </tr>
</template>

<script type="text/babel">
  import PaymentItem from '../../Payment/Item'

  import IntermediaryBusiness from './OrderIntermediaryBusiness'
  import OrderPayer from './OrderPayer'

  export default {

    name: "OrdersTabContentItem",

    props: ["order"],

    components: {
      PaymentItem,
      IntermediaryBusiness,
      OrderPayer
    },

    data () {
      return {
        toggled:false,
        captureButtonDisabled: false,
        cancelButtonDisabled: false
      }
    },

    computed: {
      sapId() {
        return this.order.erp_id !== null ? this.order.erp_id : 'Pas dans SAP'
      },

      recoveryData() {
        return this.order.validation_method == 'recovery-data'
      },

      orderType() {
        let type = 'N/A'
        let suborders = this.order.suborders
        let distributionMethod

        if ( suborders.length > 0 )
        {
          distributionMethod = suborders[0].offer.distribution_method
          
          type = distributionMethod.contract ? distributionMethod.display_name : 'Commande'
        }
        
        return type
      },

      promoCode() {
        return this.order.sap_promo_code ? this.order.sap_promo_code : '-'
      }
    },

    methods: {
      toggleDetails(order_id)
      {
        this.toggled = !this.toggled
        this.$emit('toggle-order-detail', order_id)
      },

      checkDateIsNotEqual(date0, date1)
      {
        return !moment(date0).isSame(moment(date1))
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '~pages_sass/_var.scss';

  td {
    &:first-child {
      &::before {
        display: none !important;
      }
    }
  }

  .customer-link {
    background: none;
  }

  .item-order-row {
    height:50px;
  }

  .payment-status {
    font-weight: bold;
  }
  .payment-buttons button { 
    display: inline-block;
    margin-top: 5px; 
  }
  .ib-association-button { margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// client/components/Customer/OrdersTabContent/Item.vue